import React from "react";
import styled, { keyframes } from "styled-components";
import lockIcon from "@assets/images/icons/lock.svg";

export const Container = styled.div`
  background: #2c2c2c;
  display: flex;
  flex-direction: column;
  padding: 8px 30px;
  color: #fff;
  font-family: "proxima-nova", sans-serif;
  font-size: 20px;

  span {
    padding-bottom: 12px;
    a:visited {
      color: #fff;
    }
  }

  ol {
    counter-reset: item;
    list-style-type: none;
    margin-left: 0;
    margin-bottom: 0;
    li {
      margin-bottom: 0;
      ::before {
        content: counter(item) ") ";
        counter-increment: item;
      }
    }
  }
`;

export const Title = styled.h4`
  font-size: 22px;
  font-family: "proxima-nova", sans-serif;
  &:after {
    content: " | " url(${lockIcon});
  }
`;

export const SwitchContainer = styled.div`
  border: solid 1px #ff4400;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > div {
    padding: 8px 16px;
    display: flex;
    flex-direction: column;

    :not(:last-child) {
      border-bottom: solid 1px #ff4400;
    }

    span {
      display: flex;
      padding: 8px 0;
      column-gap: 20px;
      align-items: center;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding: 20px 0 8px 0;
  gap: 10px;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }

  @media (max-width: 950px) {
    margin-top: 20px;
    flex-direction: column;

    a,
    div,
    button {
      width: 100%;
    }
  }
`;

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label`
  position: relative;
  display: inline-block;
  font-size: ${({ size }) => {
    switch (size) {
      case "xs":
        return "6px";
      case "sm":
        return "8px";
      case "lg":
        return "12px";
      default:
        return "10px";
    }
  }};
  min-width: 6em;
  width: 6em;
  height: 3.4em;

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  ${Input} {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ff4400;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 3.4em;

  &::before {
    position: absolute;
    content: "";
    height: 2.6em;
    width: 2.6em;
    left: 0.4em;
    bottom: 0.4em;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${Input}:checked + & {
    background-color: #5bc337;
  }

  ${Input}:checked + &::before {
    -webkit-transform: translateX(2.6em);
    -ms-transform: translateX(2.6em);
    transform: translateX(2.6em);
  }

  ${Input}:focus + & {
    box-shadow: 0 0 0.1em #2196f3;
  }

  ${Input}:disabled + & {
    pointer-events: none;
    background: #e6e6e6;
  }
`;

export const Switch = ({ id, disabled, title, size, ...rest }) => (
  <Label htmlFor={id} disabled={disabled} title={title} size={size}>
    <Input id={id} type="checkbox" disabled={disabled} {...rest} />
    <Slider />
  </Label>
);
